import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { logoutAction } from '../actions/authActions';
import { logoutUser } from '../services/authService';
import { useAppSelector, useAppDispatch } from '../store';
import { useSessionId } from '../hooks/useSessionId';

import Icon from './icon';

import { CLIENT_URL, DOMAIN_NAME } from '../config/api';
import { ymEvent } from '../hooks/useYandexMetrika';
import { YandexMetrikaEvent } from '../types/metrica/YandexMetrikaEvent';

interface HeaderProps {
  className?: string;
  toggleSidebar: () => void;
  isSidebarOpen: boolean;
}

const Header = ({ className, toggleSidebar, isSidebarOpen }: HeaderProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.auth.user);

  const email = user?.email || '';
  const name = user?.name || '';
  const sessionId = useSessionId();

  const onLogoutClick = async () => {
    ymEvent(YandexMetrikaEvent.LK_CABINET_HEADER_CLICK_LOGOUT);
    // Гасим обе стороны: у человека может быть и токен, и старая сессия.
    await logoutUser(sessionId);
    dispatch(logoutAction());
    navigate('/login');
  };

  const onSidebarTriggerClick = () => {
    if (!toggleSidebar || typeof toggleSidebar !== 'function') return;

    toggleSidebar();
  };

  return (
    <header className={`header ${className}`}>
      <div className="header-trigger">
        <button
          className={cn('trigger', { 'is-active': isSidebarOpen })}
          onClick={onSidebarTriggerClick}
        >
          <svg
            className="trigger-icon"
            width="32"
            height="32"
            aria-hidden="true"
          >
            <use
              className="trigger-ellipsis"
              xlinkHref="/sprite.svg#ellipsis"
            />
            <use className="trigger-times" xlinkHref="/sprite.svg#times" />
          </svg>
        </button>
      </div>

      <div className="header-logo">
        <a className="logo" href={CLIENT_URL} target="_blank">
          {DOMAIN_NAME}
        </a>
      </div>

      <div className="header-user">
        <p className="header-username">{name}</p>
        <p className="text-royalblue mb-2">{email}</p>
        <button className="header-logout" onClick={onLogoutClick}>
          Выйти
          <Icon
            name="signout"
            className="fill-current ml-2"
            width={14}
            height={14}
          />
        </button>
      </div>
    </header>
  );
};

export default Header;
